import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://lgblmjqpacthsgqignjh.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxnYmxtanFwYWN0aHNncWlnbmpoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODEyNDk2MTMsImV4cCI6MjA5NjgyNTYxM30.M8b4m-USV_Ss0Y9uhu2uaFqfEsMA49_yL5P5K849DOo';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
